module.exports = __webpack_public_path__ + "media/images/lb/191-34873214dfaf05d96478fd7ccaa70030.svg";